import React from 'react';
import { FactoryIcon, BoltIcon, CartIcon, TruckIcon } from '../components/Icons';
import PageHero from '../components/PageHero';
const INDUSTRIES = [
  {
    icon: <FactoryIcon />, tag: 'Manufacturing',
    title: 'Manufacturing',
    desc: 'Connect SAP ERP, shop-floor systems, WMS and quality platforms for end-to-end production visibility.',
    items: ['Shop-floor integration', 'Quality & compliance systems', 'Supply chain visibility', 'OEE & production analytics', 'SAP IS-Manufacturing'],
  },
  {
    icon: <BoltIcon />, tag: 'Utilities',
    title: 'Utilities',
    desc: 'Modernize SAP IS-U, field operations, asset management and billing system integrations.',
    items: ['SAP IS-U integration', 'Field operations platforms', 'Asset management systems', 'Meter data management', 'Regulatory reporting'],
  },
  {
    icon: <CartIcon />, tag: 'Retail',
    title: 'Retail',
    desc: 'Build omnichannel retail operations connecting orders, inventory, CRM and fulfilment platforms.',
    items: ['Omnichannel order management', 'Real-time inventory sync', 'Customer 360° CRM', 'E-commerce integrations', 'Loyalty & marketing platforms'],
  },
  {
    icon: <TruckIcon />, tag: 'Logistics',
    title: 'Logistics',
    desc: 'Integrate TMS, WMS, ERP and mobile platforms for warehousing and transportation visibility.',
    items: ['TMS / WMS integration', 'Mobile check-in / check-out', 'Carrier connectivity', 'Track & trace platforms', 'Customs & compliance'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round">
        <rect x="3" y="10" width="18" height="11" rx="2"/>
        <path d="M7 10V7a5 5 0 0 1 10 0v3"/>
      </svg>
    ), tag: 'Financial',
    title: 'Financial Services',
    desc: 'Automate customer operations, compliance workflows and financial system integrations.',
    items: ['CRM & case management', 'Payment & dispute workflows', 'Compliance reporting', 'Core banking integrations', 'Customer self-service portal'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
        <path d="M12 8v4M12 16h.01"/>
      </svg>
    ), tag: 'Healthcare',
    title: 'Healthcare',
    desc: 'Integrate clinical, operational and administrative systems with compliance and data security.',
    items: ['HL7 / FHIR integrations', 'EHR connectivity', 'Claims & billing workflows', 'Compliance & HIPAA', 'Patient portal integration'],
  },
];

export default function Industries() {
  return (
    <>
      <PageHero
        modifier="industries"
        kicker="Industry Focus"
        title="Industries"
        desc="Deep expertise in sectors where integration, data modernization and ERP transformation deliver measurable business value."
      />
      <section className="section">
        <div className="container grid grid-3 animate-cards">
          {INDUSTRIES.map((ind, i) => (
            <div className="card card--industry" key={i}>
              <div className="card-tag">{ind.tag}</div>
              <div className="icon-circle">{ind.icon}</div>
              <h3>{ind.title}</h3>
              <p>{ind.desc}</p>
              <ul>{ind.items.map((item, j) => <li key={j}>{item}</li>)}</ul>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
